import { useMyPermissions } from '@/features/users-roles/hooks/use-permissions';
import type { Permission } from '@/features/users-roles/constants';

export function usePermissions() {
    const { data: permissions = [], isLoading, isError, refetch } = useMyPermissions();

    return {
        permissions,
        isLoading,
        /**
         * The fetch failed, so `permissions` is the `[]` fallback rather than a
         * real answer. Callers that gate UI MUST branch on this before trusting
         * `hasPermission`: without it a 401, a network drop or a backend restart
         * is indistinguishable from a genuine denial, and the user is told they
         * lack access when they only need to retry. The backend restarts on
         * every deploy to run migrations, so this is a routine state, not an
         * exotic one.
         */
        isError,
        /** Retry the permissions fetch — pair with `isError` in a retry action. */
        refetch,
        hasPermission: (p: Permission): boolean => permissions.includes(p),
        hasAnyPermission: (ps: Permission[]): boolean => ps.some((p) => permissions.includes(p)),
        hasAllPermissions: (ps: Permission[]): boolean => ps.every((p) => permissions.includes(p)),
    };
}
